import React from 'react';
import Helmet from 'react-helmet';
import AccountFinderHeader from '../../components/AccountFinderHeader/AccountFinderHeader';

import { accountTypes } from '../../components/AccountTypeExpander/AccountTypeExpander.util';
import styles from './AccountFinder.css';
import AccountTypeExpander from '../../components/AccountTypeExpander/AccountTypeExpander';
import TransferSectional from '../../components/TransferSectional/TransferSectional';
import AccountFinderHelp from '../../components/AccountFinderHelp/AccountFinderHelp';
import directionalArrow from '../../images/saved-app-arrow.svg';
import { CANONICAL_PATH } from '../../utils/constants';
import AccountFinderDisclaimer from './AccountFinderDisclaimer';

const AccountFinder = ({
    match: {
        params: { expandType }
    }
}) => (
    <React.Fragment>
        <Helmet>
            <title>Account Finder | T. Rowe Price</title>
            <link rel="canonical" href={`${CANONICAL_PATH}/account-finder`} />
        </Helmet>
        <div className="top-container">
            <div className="finished-saved-lang">
                <a
                    className="finish-app-link"
                    href="/personal-investing/new-account/setup/return-journey/email"
                >
                    Finish a saved application{' '}
                    <img src={directionalArrow} alt="Transition Arrow" />
                </a>
            </div>
            <AccountFinderHeader />
            <AccountTypeExpander
                sections={accountTypes}
                defaultExpanded={expandType}
            />

            <div className="view-all-accounts">
                <div>Can&apos;t find the account you&apos;re looking for?</div>
                <a
                    href="/personal-investing/account-finder/all-t-rowe-price-accounts.html"
                    className="view-all-link"
                >
                    View All Account Types
                </a>
            </div>

            <TransferSectional />

            <AccountFinderHelp />

            <AccountFinderDisclaimer />

            <style jsx>{styles}</style>
        </div>
    </React.Fragment>
);

export default AccountFinder;
